// extracted by mini-css-extract-plugin
export default {"main":"login_main__Q1GBn","login":"login_login__AfWIP"};